var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 149,
    viewBox: "0 0 147 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_237)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.088 84.6876C152.487 44.7926 125.179 7.28836 85.0937 0.919629C45.0083 -5.4491 7.32521 21.7294 0.926095 61.6244C-5.47302 101.519 21.8351 139.024 61.9205 145.392C102.006 151.761 139.689 124.583 146.088 84.6876Z",
    fill: "#26ABDB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 149,
    height: 148
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.088 84.6876C152.487 44.7926 125.179 7.28836 85.0937 0.919629C45.0083 -5.4491 7.32521 21.7294 0.926095 61.6244C-5.47302 101.519 21.8351 139.024 61.9205 145.392C102.006 151.761 139.689 124.583 146.088 84.6876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_237)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8611 68.6499C39.4537 69.251 38.1897 120.12 47.1647 130.534H98.0093C98.0093 130.534 111.9 91.4773 102.434 68.6499H39.5661",
    fill: "#49130F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3882 96.6211H60.2411V115.492H88.3882V96.6211Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0672 110.264C71.3089 111.942 75.958 112.948 80.5227 112.99C83.1352 113.004 85.8038 112.683 88.3882 112.235V96.6211H60.2411V106.378C62.2215 108.112 64.7497 109.356 67.0672 110.264Z",
    fill: "#EDEDED"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.779 61.1012C104.878 60.4022 106.057 59.2699 106.577 58.8925C107.729 58.0398 108.895 58.9205 109.232 60.0248C109.527 61.0173 109.555 62.1356 109.639 63.156C109.822 65.6582 109.428 68.1185 108.305 70.3831C107.546 71.8928 106.366 73.1369 104.962 74.0735C104.962 74.0735 103.445 74.8283 103.15 73.095L104.793 61.1012H104.779Z",
    fill: "#F9C2A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.541 62.5968C104.611 62.0936 105.453 61.2968 105.833 61.0172C106.661 60.4021 107.49 61.0312 107.743 61.828C107.954 62.5409 107.982 63.3377 108.038 64.0646C108.164 65.8539 107.883 67.6152 107.083 69.2367C106.535 70.3131 105.692 71.2077 104.681 71.8787C104.681 71.8787 103.599 72.4099 103.389 71.1798L104.569 62.5968H104.541Z",
    fill: "#E1B099"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1337 61.1012C43.0353 60.4022 41.8555 59.2699 41.3358 58.8925C40.1841 58.0398 39.0183 58.9205 38.6812 60.0248C38.3722 61.0173 38.3442 62.1356 38.2739 63.156C38.1054 65.6582 38.4846 68.1185 39.6082 70.3831C40.3667 71.8928 41.5465 73.1369 42.9511 74.0735C42.9511 74.0735 44.468 74.8283 44.7629 73.095L43.1196 61.1012H43.1337Z",
    fill: "#F9C2A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3724 62.5968C43.3022 62.0936 42.4595 61.2968 42.0802 61.0172C41.2516 60.4021 40.4229 61.0312 40.1841 61.828C39.9734 62.5409 39.9453 63.3377 39.8892 64.0646C39.7627 65.8539 40.0437 67.6152 40.8442 69.2367C41.392 70.3131 42.2348 71.2077 43.246 71.8787C43.246 71.8787 44.3275 72.4099 44.5523 71.1798L43.3724 62.5968Z",
    fill: "#E1B099"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.706 63.3516C105.706 71.2636 104.33 79.2595 100.594 86.0951C97.3212 92.0781 92.4052 96.8728 87.1241 100.703C82.8403 103.806 78.2474 107.427 72.8399 106.979C67.1936 106.518 62.7974 101.723 58.668 97.9911C52.8672 92.7351 48.2884 86.207 45.4652 78.5186C43.7236 73.7798 42.923 68.4399 42.923 63.3377C42.923 37.7704 56.9825 21.6948 74.3147 21.6948C91.6468 21.6948 105.706 37.7704 105.706 63.3377V63.3516Z",
    fill: "#F9C2A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.139 124.02L86.5763 114.892H62.0529L31.49 124.02C31.49 124.02 17.3321 130.017 15.759 148.986H132.884C131.311 130.017 117.139 124.02 117.139 124.02Z",
    fill: "#F9C2A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.139 124.019L100.243 118.973L74.3146 144.75L48.3165 118.987L31.49 124.006C31.49 124.006 17.3321 130.002 15.759 148.972H132.884C131.311 130.002 117.139 124.006 117.139 124.006V124.019Z",
    fill: "#1A7290"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0077 31.8576C53.0077 31.8576 68.1206 55.7194 105.608 59.7872C105.608 59.7872 112.701 32.5985 86.3376 19.3885C86.3376 19.3885 66.1683 11.0991 53.0077 31.8716V31.8576Z",
    fill: "#712222"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8842 36.6945C56.8842 36.6945 47.1226 42.9849 42.8809 60.5283C42.8809 60.5283 38.3442 27.4685 61.8282 23.3447L56.8702 36.7085L56.8842 36.6945Z",
    fill: "#432918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2003 57.0336C95.2003 57.0336 105.257 120.721 89.3573 138.754C89.3573 138.754 109.681 135.748 110.692 107.902C110.692 107.902 114.316 51.0227 100.566 31.3965L95.2003 57.0336Z",
    fill: "#712222"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.193 138.754C52.193 138.754 28.7933 135.986 35.2261 64.3725C35.2261 64.3725 36.8413 24.5888 60.2411 23.6802L58.8927 38.7773C58.8927 38.7773 45.4371 42.7612 47.1788 74.2415C47.1788 74.2415 45.8164 124.943 52.193 138.768V138.754Z",
    fill: "#712222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profilePicture.a720313370af82f6c25c9c0d4507ab5b.svg";
export { ForwardRef as ReactComponent };